import { render, staticRenderFns } from "./PaginationBrandme.vue?vue&type=template&id=cfdaac78&scoped=true&"
import script from "./PaginationBrandme.vue?vue&type=script&lang=js&"
export * from "./PaginationBrandme.vue?vue&type=script&lang=js&"
import style0 from "./PaginationBrandme.vue?vue&type=style&index=0&id=cfdaac78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdaac78",
  null
  
)

export default component.exports